import React from 'react';
import { Route, Routes, useLocation } from "react-router-dom";
import PermissionGuard from '../common/components/PermissionGuard';

import Dashboard from './dashboard/dashboard'
import DashboardSmpp from './dashboard/smpp'
import DataSources from './settings/data_sources'
import ActiveCalls from './dashboard/active_calls'
import SystemLog from './dashboard/system_log'
import CarrierMain from './carriers/carriers/main'
import CarrierEdit from './carriers/carriers/edit'
import CarrierCreate from './carriers/carriers/create'
import CarrierPayments from './carriers/carriers/payments'
import CarrierVoiceAccounts from './carriers/carriers/voiceaccounts'
import CarrierVoiceAccountsCreateEgress from './carriers/carriers/voiceaccounts/createEgress'
import CarrierVoiceAccountsCreateIngress from './carriers/carriers/voiceaccounts/createIngress'
import CarrierVoiceAccountEdit from './carriers/carriers/voiceaccounts/edit'
import CarrierSmppAccounts from './carriers/carriers/smppaccounts'
import CarrierSmppAccountsCreateClient from './carriers/carriers/smppaccounts/createClient'
import CarrierSmppAccountsEditClient from './carriers/carriers/smppaccounts/editClient'
import CarrierSmsLog from './carriers/carriers/smslog'
import CarrierVoiceCdr from './carriers/carriers/voicecdr.jsx'
import CarrierSummary from './carriers/carriers/summary.jsx'
import CarrierBilling from './carriers/carriers/billing.jsx'
import CarrierBillingCreate from './carriers/carriers/billingCreate.jsx'
import CarrierSettingsIndex from './carriers/settings/index'
import CarrierSettingsRewriteGroups from './carriers/settings/rewritegroups';
import CarrierSettingsRewriteItems from './carriers/settings/rewriteitems';
import CarrierSettingsRewriteIndex from './carriers/settings/rewiteindex';
import CarrierSettingsCalleridGroups from './carriers/settings/calleridgroups';
import CarrierSettingsCalleridItems from './carriers/settings/calleriditems';
import CarrierSettingsSipheadersGroups from './carriers/settings/sipheadergroups';
import CarrierSettingsSipheadersItems from './carriers/settings/sipheaderitems';
import NanpaCodes from './settings/nanpa_codes'
import ClientCreate from './clients/create'
import ClientAccountEdit from './clients/accounts/edit'
import ClientAccountAliases from './clients/accounts/aliases'
import ClientAccountVoiceCdr from './clients/accounts/voicecdr'
import ClientAccountNumbers from './clients/accounts/numbers'
import ClientAccountNumbersCreate from './clients/accounts/numbers/create'
import ClientAccountNumbersEdit from './clients/accounts/numbers/edit'
import ClientAccountApi from './clients/accounts/api'
import ClientAccountApiTokens from './clients/accounts/apitokens'
import ClientAccountWebAccounts from './clients/accounts/webaccounts'
import ClientAccountWebAccountsCreate from './clients/accounts/webaccounts/create'
import ClientAccountWebAccountsEdit from './clients/accounts/webaccounts/edit'
import ClientAccountSmppAccounts from './clients/accounts/smppaccounts'
import ClientAccountSmppAccountsCreate from './clients/accounts/smppaccounts/create'
import ClientAccountSmppAccountsEdit from './clients/accounts/smppaccounts/edit'
import ClientAccountMmsAccounts from './clients/accounts/mmsaccounts'
import ClientAccountSmsDids from './clients/accounts/smsdids'
import ClientAccountSmsLog from './clients/accounts/smslog'
import ClientAccountSummary from './clients/accounts/summary'
import ClientAccountBilling from './clients/accounts/billing'
import ClientAccountBillingCreate from './clients/accounts/billing/create'
import ClientAccountInvoices from './clients/accounts/invoices'
import ClientsAccounts from './clients/accounts/accounts'
import ClientAccountWebhooks from './clients/accounts/client_webhooks'
import ClientsList from './clients/clients'
import ClientCompaniesIndex from './clients/companies'
import ClientCompaniesCreate from './clients/companies/create'
import ClientCompaniesEdit from './clients/companies/edit'
import ClientBranchesIndex from './clients/branches'
import ClientBranchesCreate from './clients/branches/create'
import ClientBranchesEdit from './clients/branches/edit'
import ClientTeamsIndex from './clients/teams'
import ClientTeamsCreate from './clients/teams/create'
import ClientTeamsEdit from './clients/teams/edit'
import ResellersList from './resellers/list.jsx'
import ResellerCreate from './resellers/create.jsx'
// import ResellerMain from './admin/resellers/main'
import ResellerEdit from './resellers/edit.jsx'
// import ResellerCarriers from './admin/resellers/carriers'
// import ResellerClients from './admin/resellers/clients'
import CarriersList from './carriers/carriers'
import SmsRouting from './routing/sms/index'
import SmsRoutingGroups from './routing/sms/groups'
import SmsRoutingMaster from './routing/sms/master'
import SmsRoutingRoutes from './routing/sms/routes'
import SmsRoutingSrcNumbers from './routing/sms/srcnumbers'
import SmsRates from './products/sms/rates/index'
import SmsRateList from './products/sms/rates/list'
import SmsRateView from './products/sms/rates/view'
import SmsRateCreate from './products/sms/rates/create'
import SmsRateUpload from './products/sms/rates/upload'
import SmsRateItemCreate from './products/sms/rates/items/create'
import MmsRates from './products/mms/rates/index'
import MmsRateList from './products/mms/rates/list'
import MmsRateView from './products/mms/rates/view'
import SmsMasterCodeList from './products/sms_master_codes/list'
import SmsMasterCodeCreate from './products/sms_master_codes/create'
import SmsMasterCodeEdit from './products/sms_master_codes/edit'
import SmsMasterCodePrefixesList from './products/sms_master_codes/prefixes/list'
import SmsMasterCodePrefixesCreate from './products/sms_master_codes/prefixes/create'
import VoiceRates from './products/voice/rates/index'
import VoiceRateCreate from './products/voice/rates/create'
import VoiceRateList from './products/voice/rates/list'
import VoiceRateView from './products/voice/rates/view'
import VoiceRateUpload from './products/voice/rates/upload'
import VoiceRateItemCreate from './products/voice/rates/items/create'
import ContactsList from './contacts/view'
import AiAgents from './ai/agents';
import AiAgentsCreate from './ai/agents/create';
import AiAgentsEdit from './ai/agents/edit';
import AiTasks from './ai/tasks';
import AiTasksCreate from './ai/tasks/create';
import AiTasksEdit from './ai/tasks/edit';
import AiTools from './ai/tools';
import AiToolsCreate from './ai/tools/create';
import AiToolsEdit from './ai/tools/edit';
import LLMModels from './ai/llm-models';
import LLMModelsCreate from './ai/llm-models/create';
import LLMModelsEdit from './ai/llm-models/edit';
import AiSpeechStyles from './ai/speech_styles';
import AiSpeechStylesCreate from './ai/speech_styles/create';
import AiSpeechStylesEdit from './ai/speech_styles/edit';
import AiCallLogs from './ai/call_logs';
import AiCallLogDetails from './ai/call_logs/details';
import AiTranscripts from './ai/transcripts';
import AiTranscriptDetails from './ai/transcripts/details';
import Numbers from './numbers/numbers/index'
import NumberCreate from './numbers/numbers/create'
import NumberEdit from './numbers/numbers/edit'
import NumberChargeGroups from './numbers/charge_groups/index'
import NumberPools from './numbers/number_pools/index'
import ProductsMain from './products/main'
import Products from './products/products'
import ProductCreate from './products/create'
import ProductsCallerIdIndex from './products/calleridindex'
import ProductsCallerIdGroups from './products/calleridgroups'
import ProductsCallerIdItems from './products/calleriditems'
import ProductMapping from './products/mapping'
import ReportsIndex from './reports/index'
import ReportsBilling from './reports/billing'
import ReportsInvoices from './reports/invoices/details'
import ReportsInvoicesList from './reports/invoices/list'
import ReportsPaymentsList from './reports/payments'
import ReportsSmsLog from './reports/sms/smslog'
import ReportsSmsIndex from './reports/sms/index'
import ReportsSmsSummary from './reports/sms/summary'
import ReportsSmsSurcharges from './reports/sms/surcharges'
import ReportsVoiceIndex from './reports/voice/index'
import ReportsVoiceSummary from './reports/voice/summary'
import ReportsVoiceMismatches from './reports/voice/mismatches'
import ReportsCdrLog from './reports/voice/cdr'
import AdminUsers from './admin/users/list'
import AdminUsersCreate from './admin/users/create'
import AdminUsersEdit from './admin/users/edit'
import CurrenciesList from './settings/currencies/list'
import CurrencyCreate from './settings/currencies/create'
import CurrencyEdit from './settings/currencies/edit'
import PaymentTermsList from './settings/payment_terms/list'
import PaymentTermCreate from './settings/payment_terms/create'
import PaymentTermEdit from './settings/payment_terms/edit'
import InvoiceTemplatesList from './settings/invoice_templates/list'
import InvoiceTemplateCreate from './settings/invoice_templates/create'
import InvoiceTemplateEdit from './settings/invoice_templates/edit'
import MessageTemplatesList from './messages/templates/list'
import MessageTemplateCreate from './messages/templates/create'
import MessageTemplateEdit from './messages/templates/edit'
import MailAccountsList from './settings/mail_accounts/list'
import MailAccountCreate from './settings/mail_accounts/create'
import MailAccountEdit from './settings/mail_accounts/edit'
import TTSVoicesList from './settings/tts_voices/list'
import TTSVoiceCreate from './settings/tts_voices/create'
import TTSVoiceEdit from './settings/tts_voices/edit'
// Access Management imports
import AccessManagement from './admin/access/index'
import AccessGroups from './admin/access/groups/index'
import AccessGroupsCreate from './admin/access/groups/create'
import AccessGroupsEdit from './admin/access/groups/edit'
import AccessAreas from './admin/access/areas/index'
import AccessAreasCreate from './admin/access/areas/create'
import AccessAreasEdit from './admin/access/areas/edit'
import AccessRights from './admin/access/rights/index'
import AccessRightsCreate from './admin/access/rights/create'
import AccessRightsEdit from './admin/access/rights/edit'
import AccessRightsBulkEdit from './admin/access/rights/bulk-edit'
import UserAssignments from './admin/access/user-assignments/index'
import MyProfile from './myprofile'
import Developer from './developer'
import Help from './help'
import { AuthContext } from './App';
import { PrivateHome } from './PrivateHome';
import Login from './Login'
import { usePermissions } from '../common/hooks/usePermissions';
import SendSms from './tools/send_sms'
import AutomationsIndex from './automations/index'
import AutomationsCreate from './automations/create'
import AutomationsEdit from './automations/edit'
import CampaignsIndex from './campaigns/index'
import CampaignsCreate from './campaigns/create'
import CampaignsEdit from './campaigns/edit'
import CampaignsScheduler from './campaigns/scheduler'
// Redirect component for /profile to /myprofile
const ProfileRedirect = () => {
    React.useEffect(() => {
        window.location.href = '/myprofile';
    }, []);
    return null;
};

export const PREFIX = '';

const routes =
    [
        {
            path: PREFIX + 'login', component: Login,
            exact: true
        },
        {
            path: '/', component: Dashboard,
            exact: true
        },
        {
            path: 'dashboard', component: Dashboard,
            exact: true
        },
        {
            path: 'home',
            component: Dashboard,
            routes: [
                {path: '', component: Dashboard},
                {path: 'dashboard', component: Dashboard},
                {path: 'active_calls', component: ActiveCalls},
                {path: 'system_log', component: SystemLog}
            ]
        },
        {
            path: 'home/smpp/:server_id', component: DashboardSmpp,
            exact: true
        },
        {
            path: 'home/smpp', component: DashboardSmpp,
            exact: true
        },
        {
            path: 'tools/send_sms', component: SendSms,
            exact: true
        },
        {
            path: 'automations', component: AutomationsIndex,
            exact: true
        },
        {
            path: 'automations/create', component: AutomationsCreate,
            exact: true
        },
        {
            path: 'automations/:id', component: AutomationsEdit,
            exact: true
        },
        {
            path: 'campaigns/campaigns', component: CampaignsIndex,
            exact: true
        },
        {
            path: 'campaigns/campaigns/create', component: CampaignsCreate,
            exact: true
        },
        {
            path: 'campaigns/campaigns/:campaign_id', component: CampaignsEdit,
            exact: true
        },
        {
            path: 'campaigns/scheduler', component: CampaignsScheduler,
            exact: true
        },
        {
            path: 'messages/templates', component: MessageTemplatesList,
            exact: true
        },
        {
            path: 'messages/templates/create', component: MessageTemplateCreate,
            exact: true
        },
        {
            path: 'messages/templates/:id', component: MessageTemplateEdit,
            exact: true
        },
        {
            path: 'myprofile', component: MyProfile,
            exact: true
        },
        {
            path: 'profile', component: ProfileRedirect,
            exact: true
        },
        {
            path: 'developer', component: Developer,
            exact: true
        },
        {
            path: 'help', component: Help,
            exact: true
        },
        {
            path: 'clients/clients',
            component: ClientsList,
            exact: true,
            indexRoute: {component: ClientsList}
        },
        {
            path: 'clients/clients/add',
            component: ClientCreate,
            exact: true
        },
        {
            path: 'clients/clients/:account_id/*',
            component: ClientsAccounts,
            routes: [
                {path: 'edit', component: ClientAccountEdit},
                {path: 'aliases', component: ClientAccountAliases},
                {path: 'voicecdr', component: ClientAccountVoiceCdr},
                {path: 'summary', component: ClientAccountSummary},
                {path: 'billing', component: ClientAccountBilling},
                {path: 'billing/create', component: ClientAccountBillingCreate},
                {path: 'numbers', component: ClientAccountNumbers},
                {path: 'numbers/create', component: ClientAccountNumbersCreate},
                {path: 'numbers/:id/edit', component: ClientAccountNumbersEdit},
                {path: 'invoices', component: ClientAccountInvoices},
                {path: 'webaccounts/:webaccount_id', component: ClientAccountWebAccountsEdit},
                {path: 'webaccounts/create', component: ClientAccountWebAccountsCreate},
                {path: 'webaccounts', component: ClientAccountWebAccounts},
                {path: 'api', component: ClientAccountApi},
                {path: 'apitokens', component: ClientAccountApiTokens},
                {path: 'smppaccounts', component: ClientAccountSmppAccounts},
                {path: 'smppaccounts/create', component: ClientAccountSmppAccountsCreate},
                {path: 'smppaccounts/:id', component: ClientAccountSmppAccountsEdit},
                {path: 'mmsaccounts', component: ClientAccountMmsAccounts},
                {path: 'smsdids', component: ClientAccountSmsDids},
                {path: 'smslog', component: ClientAccountSmsLog},
                {path: 'client_webhooks', component: ClientAccountWebhooks}
            ]
        },
        { path: 'clients/companies', component: ClientCompaniesIndex },
        { path: 'clients/companies/create', component: ClientCompaniesCreate },
        { path: 'clients/companies/:companyId', component: ClientCompaniesEdit },
        { path: 'clients/branches', component: ClientBranchesIndex },
        { path: 'clients/branches/create', component: ClientBranchesCreate },
        { path: 'clients/branches/:branchId', component: ClientBranchesEdit },
        { path: 'clients/teams', component: ClientTeamsIndex },
        { path: 'clients/teams/create', component: ClientTeamsCreate },
        { path: 'clients/teams/:teamId', component: ClientTeamsEdit },
        {
            path: 'resellers/resellers',
            component: ResellersList,
            exact: true,
            indexRoute: {component: ResellersList}
        },
        {
            path: 'resellers/resellers/create',
            component: ResellerCreate,
            exact: true
        },
        {
            path: 'resellers/resellers/:reseller_id',
            component: ResellerEdit,
            exact: true,
        },
        {
            path: 'carriers/carriers/create',
            component: CarrierCreate,
            exact: true
        },
        {
            path: 'carriers/carriers',
            component: CarriersList,
            exact: true,
            indexRoute: {component: CarriersList}
        },
        {
            path: 'carriers/settings/*',
            component: CarrierSettingsIndex,
            routes: [
                {path: 'rewrite/:group_id', component: CarrierSettingsRewriteItems},
                {path: 'rewrite', component: CarrierSettingsRewriteGroups},
                {path: 'callerid/:group_id', component: CarrierSettingsCalleridItems},
                {path: 'callerid', component: CarrierSettingsCalleridGroups},
                {path: 'sipheaders/:group_id', component: CarrierSettingsSipheadersItems},
                {path: 'sipheaders', component: CarrierSettingsSipheadersGroups},
                {component: CarrierSettingsRewriteIndex}
            ]
        },
        {
            path: 'carriers/carriers/:carrier_id/*',
            component: CarrierMain,
            routes: [
                {path: 'voiceaccounts/create_egress', component: CarrierVoiceAccountsCreateEgress},
                {path: 'voiceaccounts/create_ingress', component: CarrierVoiceAccountsCreateIngress},
                {path: 'voiceaccounts/:voiceaccount_id', component: CarrierVoiceAccountEdit},
                {path: 'smppaccounts/create_client', component: CarrierSmppAccountsCreateClient},
                {path: 'smppaccounts/client/:client_id', component: CarrierSmppAccountsEditClient},
                {path: 'edit', component: CarrierEdit},
                {path: 'payments', component: CarrierPayments},
                {path: 'voiceaccounts', component: CarrierVoiceAccounts},
                {path: 'smppaccounts', component: CarrierSmppAccounts},
                {path: 'smslog', component: CarrierSmsLog},
                {path: 'voicecdr', component: CarrierVoiceCdr},
                {path: 'summary', component: CarrierSummary},
                {path: 'billing/create', component: CarrierBillingCreate},
                {path: 'billing', component: CarrierBilling},
                {component: CarrierEdit}
            ]
        },
        {
            path: 'routing/sms/*',
            component: SmsRouting,
            routes: [
                {path: 'groups/:group_id', component: SmsRoutingRoutes},
                {path: 'master', component: SmsRoutingMaster},
                {path: 'srcnumbers', component: SmsRoutingSrcNumbers},
                {component: SmsRoutingGroups}
            ]
        },
        {
            path: 'contacts/contacts',
            component: ContactsList,
            exact: true,
            indexRoute: {component: ContactsList}
        },
        { path: 'ai/agents/create', component: AiAgentsCreate },
        { path: 'ai/agents/:agent_id', component: AiAgentsEdit },
        { path: 'ai/agents', component: AiAgents },
        { path: 'ai/tasks/create', component: AiTasksCreate },
        { path: 'ai/tasks/:task_id', component: AiTasksEdit },
        { path: 'ai/tasks', component: AiTasks },
        { path: 'ai/tools', component: AiTools },
        { path: 'ai/tools/create', component: AiToolsCreate },
        { path: 'ai/tools/:tool_id', component: AiToolsEdit },
        { path: 'ai/llm-models', component: LLMModels },
        { path: 'ai/llm-models/create', component: LLMModelsCreate },
        { path: 'ai/llm-models/:model_id', component: LLMModelsEdit },
        { path: 'ai/speech-styles', component: AiSpeechStyles },
        { path: 'ai/speech-styles/create', component: AiSpeechStylesCreate },
        { path: 'ai/speech-styles/:speech_style_id', component: AiSpeechStylesEdit },
            { path: 'ai/call_logs/:call_id', component: AiCallLogDetails },
        { path: 'ai/call_logs', component: AiCallLogs },
        { path: 'ai/transcripts/:callId', component: AiTranscriptDetails },
        { path: 'ai/transcripts', component: AiTranscripts },
        { path: 'numbers', component: Numbers, exact: true },
        { path: 'numbers/numbers', component: Numbers, exact: true },
        { path: 'numbers/numbers/create', component: NumberCreate, exact: true },
        { path: 'numbers/numbers/:id', component: NumberEdit, exact: true },
        { path: 'numbers/charge-groups', component: NumberChargeGroups, exact: true },
        { path: 'numbers/pools', component: NumberPools, exact: true },
        {
            path: 'products/products/:product_id',
            component: ProductMapping,
            exact: true,
            indexRoute: {component: ProductMapping},
        },
        {path: 'products/sms_master_codes/prefixes',component: SmsMasterCodePrefixesList, exact: true },
        {path: 'products/sms_master_codes/prefixes/create',component: SmsMasterCodePrefixesCreate, exact: true },
        {path: 'products/sms_master_codes',component: SmsMasterCodeList, exact: true },
        {path: 'products/sms_master_codes/create',component: SmsMasterCodeCreate, exact: true },
        {path: 'products/sms_master_codes/:code_id',component: SmsMasterCodeEdit, exact: true },
        {
            path: 'products/sms/rates/*',
            component: SmsRates,
            routes: [
                {path: 'create', component: SmsRateCreate},
                {path: 'upload', component: SmsRateUpload},
                {path: ':rate_id/items/new', component: SmsRateItemCreate},
                {path: ':rate_id', component: SmsRateView },
                {component: SmsRateList}
            ]
        },
        {
            path: 'products/mmsrates/*',
            component: MmsRates,
            routes: [
                {path: ':rate_id', component: MmsRateView },
                {component: MmsRateList}
            ]
        },
        {
            path: 'products/voice/rates/*',
            component: VoiceRates,
            routes: [
                {path: 'create', component: VoiceRateCreate},
                {path: 'upload', component: VoiceRateUpload},
                {path: ':rate_id/items/new', component: VoiceRateItemCreate},
                {path: ':rate_id', component: VoiceRateView },
                {component: VoiceRateList}
            ]
        },
        {
            path: 'products/*',
            component: ProductsMain,
            routes: [
                {path: 'rate_profiles/create', component: ProductCreate},
                {path: 'rate_profiles', component: Products},
                {path: 'calleridgroups/:group_id', component: ProductsCallerIdIndex},
                {path: 'calleridgroups', component: ProductsCallerIdIndex}
            ]
        },

        { path: 'reports/billing', component: ReportsBilling, indexRoute: {component: ReportsBilling}},
        {
            path: 'reports/voice/*',
            component: ReportsVoiceIndex,
            routes: [
                {path: 'summary', component: ReportsVoiceSummary},
                {path: 'cdr', component: ReportsCdrLog},
                {path: 'mismatches', component: ReportsVoiceMismatches},
                {component: ReportsVoiceSummary}
            ]
        },
        {
            path: 'reports/sms/*',
            component: ReportsSmsIndex,
            routes: [
                {path: 'summary', component: ReportsSmsSummary},
                {path: 'smslog', component: ReportsSmsLog},
                {path: 'surcharges', component: ReportsSmsSurcharges},
                {component: ReportsSmsSummary}
            ]
        },
        { path: 'reports/invoices/:invoice_id', component: ReportsInvoices, indexRoute: {component: ReportsInvoices}},
        { path: 'reports/invoices', component: ReportsInvoicesList, indexRoute: {component: ReportsInvoicesList}},
        { path: 'reports/payments', component: ReportsPaymentsList, indexRoute: {component: ReportsPaymentsList}},
        { path: 'reports', component: ReportsIndex, indexRoute: {component: ReportsIndex}},
        { path: 'admin/users', component: AdminUsers, indexRoute: {component: AdminUsers}},
        { path: 'admin/users/create', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AdminUsersCreate {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/users/:userId', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AdminUsersEdit {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'settings/currencies', component: CurrenciesList, exact: true},
        { path: 'settings/currencies/create', component: CurrencyCreate, exact: true},
        { path: 'settings/currencies/:currency_id', component: CurrencyEdit, exact: true},
        { path: 'settings/payment_terms', component: PaymentTermsList, exact: true},
        { path: 'settings/payment_terms/create', component: PaymentTermCreate, exact: true},
        { path: 'settings/payment_terms/:payment_term_id', component: PaymentTermEdit, exact: true},
        { path: 'settings/invoice_templates', component: InvoiceTemplatesList, exact: true},
        { path: 'settings/invoice_templates/create', component: InvoiceTemplateCreate, exact: true},
        { path: 'settings/invoice_templates/:invoice_template_id', component: InvoiceTemplateEdit, exact: true},
        { path: 'settings/message_templates', component: MessageTemplatesList, exact: true},
        { path: 'settings/message_templates/create', component: MessageTemplateCreate, exact: true},
        { path: 'settings/message_templates/:template_id', component: MessageTemplateEdit, exact: true},
        { path: 'settings/mail_accounts', component: MailAccountsList, exact: true},
        { path: 'settings/mail_accounts/create', component: MailAccountCreate, exact: true},
        { path: 'settings/mail_accounts/:account_id', component: MailAccountEdit, exact: true},
        { path: 'settings/tts_voices', component: TTSVoicesList, exact: true},
        { path: 'settings/tts_voices/create', component: TTSVoiceCreate, exact: true},
        { path: 'settings/tts_voices/:voice_id', component: TTSVoiceEdit, exact: true},
        { path: 'settings/nanpa_codes', component: NanpaCodes},
        // Access Management routes
        { path: 'admin/access', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="read">
                <AccessManagement {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/groups', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="read">
                <AccessGroups {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/groups/create', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessGroupsCreate {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/groups/:groupId', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessGroupsEdit {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/areas', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="read">
                <AccessAreas {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/areas/create', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessAreasCreate {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/areas/:areaId', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessAreasEdit {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/rights', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="read">
                <AccessRights {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/rights/create', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessRightsCreate {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/rights/:rightId', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessRightsEdit {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/rights/bulk-edit', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <AccessRightsBulkEdit {...props} />
            </PermissionGuard>
        ), exact: true},
        { path: 'admin/access/user-assignments', component: (props) => (
            <PermissionGuard requiredArea="admin" requiredPermission="write">
                <UserAssignments {...props} />
            </PermissionGuard>
        ), exact: true}
    ]

const useAuth = () => {
    return React.useContext(AuthContext);
};

const ProtectedRoute = ({ children }) => {
    let { loggedIn } = useAuth();
    const location = useLocation();
    const { user, config } = usePermissions(); // <-- Always call this hook

    if (!loggedIn) {
        // Redirect to /login page with the return url
        return (
            <Routes>
                <Route path="*" element={
                    <Login returnTo={location.pathname} />
                } />
            </Routes>
        );
    }

    return <PrivateHome user={user} config={config}>{children}</PrivateHome>;
};


const AdminRoutes = ({ childProps }) => {
    return (
        <Routes>
            {routes.map((route, i) => {
                // Remove the PREFIX since Router basename handles it
                const routePath = route.path;
                
                if (route.routes) {
                    return (
                        <Route 
                            key={i}
                            path={routePath}
                            element={<ProtectedRoute><route.component routes={route.routes} childProps={childProps}/></ProtectedRoute>}
                        >
                            {route.routes.map((subRoute, j) => (
                                <Route
                                    key={j}
                                    path={subRoute.path}
                                    element={<ProtectedRoute><subRoute.component childProps={childProps}/></ProtectedRoute>}
                                />
                            ))}
                        </Route>
                    );
                }
                return (
                    <Route 
                        key={i}
                        path={routePath}
                        element={<ProtectedRoute><route.component childProps={childProps}/></ProtectedRoute>}
                    />
                );
            })}
        </Routes>       
    );
}

export default AdminRoutes;
